/**
 * A deployment's status, in the pills the rest of the app already uses: a live one reads "Booked"
 * in the approved colour, a cancelled one "Cancelled". Never "Tentative", "Confirmed" or "Approved"
 * (Jeremy, 27 Oct 2026): field work is booked when saved and nobody approves it. One component,
 * so the list and the page cannot word it differently; the words are DEPLOYMENT_STATUS_LABEL.
 */
import { DEPLOYMENT_STATUS_LABEL, type DeploymentStatus } from "@scheduler/shared";

const CLASS: Record<DeploymentStatus, string> = { CONFIRMED: "s-APPROVED", CANCELLED: "s-CANCELLED" };

export function StatusPill({ status }: { status: DeploymentStatus }) {
  return <span className={`pill ${CLASS[status]}`}>{DEPLOYMENT_STATUS_LABEL[status]}</span>;
}
